/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccountId } from "../../commons/types/AccountId";
import { AppId } from "../../commons/types/AppId";
export const Account = core.serialization.object({
    id: AccountId,
    name: core.serialization.string(),
    primaryDomain: core.serialization.string().optional(),
    subdomain: core.serialization.string().optional(),
    vanityDomainDashboard: core.serialization.string().optional(),
    vanityDomainSpaces: core.serialization.string().optional(),
    embeddedDomainWhitelist: core.serialization.list(core.serialization.string()).optional(),
    customFromEmail: core.serialization.string().optional(),
    stripeCustomerId: core.serialization.string().optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    defaultAppId: AppId.optional(),
    dashboard: core.serialization.number().optional(),
});
